var isFunction;

isFunction = require("./_helpers").isFunction;

module.exports = {
  _name: "c-for",
  _v: 1,
  mixins: [require("./structure"), require("./for")],
  _elLookup: {
    cFor: function(name, o, children) {
      var comment, ref, template;
      comment = document.createComment("c-for");
      if (isFunction(children)) {
        template = children;
      } else {
        template = (ref = o.template) != null ? ref[""] : void 0;
      }
      this.$nextTick(function() {
        var objs, ref1, ref2, ref3, ref4, ref5, ref6, tap;
        objs = this.$for({
          anchor: comment,
          template: template,
          value: (ref1 = o.iterate) != null ? ref1[""] : void 0,
          names: (ref2 = o.names) != null ? (ref3 = ref2[""]) != null ? ref3.split(",") : void 0 : void 0,
          computed: (ref4 = o.computed) != null ? ref4[""] : void 0,
          id: (ref5 = o.id) != null ? ref5[""] : void 0
        });
        if ((tap = (ref6 = o.tap) != null ? ref6[""] : void 0) != null) {
          return this.$path.setValue({
            path: tap,
            value: objs
          });
        }
      });
      return comment;
    }
  }
};

;



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/c-for.js
// module id = 67
// module chunks = 1